export default {
  path: '/clients',
  component: () => import('@/views/clients/Index'),
  redirect: { name: 'clients-groups' },
  children: [
    {
      path: 'analytics',
      name: 'clients-analytics',
      component: () => import('@/views/clients/analytics/Analytics'),
      meta: {
        title: 'Clients analytics',
        roles: ['general_manager', 'marketing_supervisor']
      },
    },
    {
      path: 'arrivals',
      name: 'clients-arrivals',
      component: () => import('@/views/clients/arrivals/List.vue'),
      meta: {
        title: 'Clients arrivals',
        roles: ['general_manager', 'operations_supervisor']
      },
    },
    {
      path: 'authorization-forms',
      component: () => import('@/views/clients/authorization-forms/Layout'),
      children: [
        {
          path: '',
          name: 'authorization-forms-pending',
          component: () => import('@/views/clients/authorization-forms/Pending'),
          meta: {
            title: 'Authorization forms',
            roles: ['general_manager', 'operations_supervisor', 'finance_manager']
          }
        },
        {
          path: 'charged',
          name: 'authorization-forms-charged',
          component: () => import('@/views/clients/authorization-forms/Charged'),
          meta: {
            title: 'Authorization forms',
            roles: ['general_manager', 'finance_manager']
          }
        }
      ]
    },
    {
      path: 'payment-control',
      component: () => import('@/views/clients/payment-control/Layout'),
      children: [
        {
          path: '',
          name: 'payment-control-groups',
          component: () => import('@/views/clients/payment-control/Next'),
          meta: {
            title: 'Payment control',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'finance_manager']
          },
        },
        {
          path: 'archive',
          name: 'payment-control-archive',
          component: () => import('@/views/clients/payment-control/Archive'),
          meta: {
            title: 'Payment control',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'finance_manager']
          },
        },
      ]
    },
    {
      path: 'dashboard',
      name: 'clients-dashboard',
      component: () => import('@/views/clients/Dashboard'),
      meta: {
        title: 'Clients dashboard',
        roles: ['general_manager', 'sales_manager', 'sales_supervisor']
      }
    },
    {
      path: 'invoices',
      name: 'clients-invoices',
      component: () => import('@/views/clients/invoices/Invoices'),
      meta: {
        title: 'Invoices',
        roles: ['general_manager', 'sales_supervisor']
      },
    },
    {
      path: 'free-days',
      component: () => import('@/views/clients/free-days/Index'),
      children: [
        {
          path: '',
          name: 'free-days-list',
          component: () => import('@/views/clients/free-days/List'),
          meta: {
            title: 'Free days',
            roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor']
          },
        },
        {
          path: ':id',
          name: 'free-days-detail',
          component: () => import('@/views/clients/free-days/Detail'),
          meta: {
            title: 'Group name (0) ID: 0',
            roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor']
          },
        }
      ]
    },
    {
      path: 'groups',
      component: () => import('@/views/clients/groups/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/clients/groups/list/Layout'),
          children: [
            {
              path: '',
              name: 'clients-groups',
              component: () => import('@/views/clients/groups/list/Upcoming'),
              meta: {
                title: 'Client groups',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support', 'finance_manager']
              },
            },
            {
              path: 'in-tour',
              name: 'clients-groups-tour',
              component: () => import('@/views/clients/groups/list/InTour'),
              meta: {
                title: 'Clients groups',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support', 'finance_manager']
              },
            },
            {
              path: 'archive',
              name: 'clients-groups-archive',
              component: () => import('@/views/clients/groups/list/Archive'),
              meta: {
                title: 'Clients groups',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support', 'finance_manager']
              },
            },
          ]
        },
        {
          path: ':id',
          component: () => import('@/views/clients/groups/detail/Layout'),
          children: [
            {
              path: '',
              name: 'clients-groups-general',
              component: () => import('@/views/clients/groups/detail/General'),
              meta: {
                title: 'Client groups',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support', 'finance_manager']
              },
            },
            {
              path: 'arrival',
              name: 'clients-groups-arrival',
              component: () => import('@/views/clients/groups/detail/Arrival'),
              meta: {
                title: 'Client groups arrival',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support', 'finance_manager']
              },
            },
            {
              path: 'departure',
              name: 'clients-groups-departure',
              component: () => import('@/views/clients/groups/detail/Departure'),
              meta: {
                title: 'Client groups departure',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support', 'finance_manager']
              },
            },
            {
              path: 'activities',
              name: 'clients-groups-activities',
              component: () => import('@/views/clients/groups/detail/Activities'),
              meta: {
                title: 'Client groups activities',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support', 'finance_manager']
              },
            },
            {
              path: 'transfers',
              name: 'clients-groups-transfers',
              component: () => import('@/views/clients/groups/detail/Transfers'),
              meta: {
                title: 'Client groups transfers',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support', 'finance_manager']
              },
            },
            {
              path: 'reservations',
              name: 'clients-groups-reservations',
              component: () => import('@/views/clients/groups/detail/Reservations'),
              meta: {
                title: 'Reservations',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support', 'finance_manager']
              },
            },
            {
              path: 'payment-control',
              name: 'clients-groups-payment-control',
              component: () => import('@/views/clients/groups/detail/PaymentControl'),
              meta: {
                title: 'Client groups payment control',
                roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'finance_manager']
              },
            },
            {
              path: 'invoices',
              name: 'clients-groups-invoices',
              component: () => import('@/views/clients/groups/detail/Invoices'),
              meta: {
                title: 'Client groups invoices',
                roles: ['general_manager', 'operations_supervisor', 'finance_manager']
              },
            },
            {
              path: 'reminders',
              name: 'clients-groups-reminders',
              component: () => import('@/views/clients/groups/detail/Reminders'),
              meta: {
                title: 'Client groups reminders',
                roles: []
              },
            },
          ]
        },
      ]
    },
    {
      path: ':id',
      name: 'clients-detail',
      component: () => import('@/views/clients/detail/Detail'),
      meta: {
        title: 'Clients detail',
        roles: ['general_manager', 'sales_manager', 'operations_manager', 'sales_supervisor', 'operations_supervisor', 'support']
      }
    },
  ]
}
